import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { getTypeBadge, formatShortDate, getDaysUntil, getDayOfWeek } from './mesJoursFeriesHelpers';

const MesJoursFeriesHolidaysList = ({ holidays }) => {
  const { t, i18n } = useTranslation();

  if (holidays.length === 0) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center py-8">
            <Calendar className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-semibold text-foreground">{t("myHolidaysComponents.empty.title")}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{t("myHolidaysComponents.empty.description")}</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  const sortedHolidays = [...holidays].sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t("holidayCommon.fields.date")}</TableHead>
              <TableHead>{t("myHolidaysComponents.table.day")}</TableHead>
              <TableHead>{t("holidayCommon.fields.name")}</TableHead>
              <TableHead>{t("holidayCommon.fields.type")}</TableHead>
              <TableHead>{t("holidayCommon.fields.description")}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedHolidays.map((holiday) => {
              const isPast = new Date(holiday.date) < new Date();
              const isToday = getDaysUntil(holiday.date) === 0;

              return (
                <TableRow
                  key={holiday.id}
                  className={isToday ? 'bg-green-950/20' : isPast ? 'opacity-50' : ''}
                >
                  <TableCell className="font-medium">{formatShortDate(holiday.date, i18n.language)}</TableCell>
                  <TableCell className="capitalize">{getDayOfWeek(holiday.date, i18n.language)}</TableCell>
                  <TableCell className="font-medium">
                    {holiday.name}
                    {isToday && <Badge className="ml-2 bg-green-500">{t("holidayCommon.today")}</Badge>}
                  </TableCell>
                  <TableCell>{getTypeBadge(holiday.type, t)}</TableCell>
                  <TableCell className="max-w-xs truncate">{holiday.description || '-'}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default MesJoursFeriesHolidaysList;
